import { PlacementsTable } from './components/PlacementsTable';

export function PlacementsPage() {
  return (
    <main className="page-gutter min-w-0 flex-1 py-6">
      <PlacementsTable />
    </main>
  );
}
